module.exports = __webpack_public_path__ + "img/VM23_0037.ec01aa50.jpg";